import React, {Component} from 'react';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';
import lscache from 'lscache'
import {Label} from "reactstrap";
import {observer} from "mobx-react";
import { Redirect } from "react-router-dom";
import {makePDF} from "../../../../utils/formatar";
import { Button } from 'reactstrap';


@observer
class ConfirmaModal extends Component {
    constructor(props) {
        super(props);
        this.controller = props.controller;

        
        this.state = {
            cancelar: false
        }
    }


    salvarDados(){
        this.controller.salvarSolicitacao();
    }


    rotina(){
        this.setState({cancelar: true});
        this.controller.setEstadoModal(false);
        this.controller.setEStadoConfirmaModal(false);

        
    }

    render() {        
        if (this.state.cancelar){
              return <Redirect to='/solicitacao-entrada-antecipada' />;
          }

        return <ModalContainer zIndex={100} className="modal-layer">
            <ModalDialog className="nosso-modal modal-escolhas">
                <h4>Realmente quer prosseguir com a solicitação?</h4>
               
                <div className="botoes">
                    <div className="justify-content-end">
                    <Label className="btn-primary"  onClick={ () => this.salvarDados()}>CONTINUAR</Label>
                    <Label className="btn-primary cinza" onClick={ () => this.rotina() }>CANCELAR</Label>
                    </div>
                </div>
            </ModalDialog>
        </ModalContainer>
    }
}
 
export default ConfirmaModal;







// WEBPACK FOOTER //
// ./src/modules/agendamento/entrada-antecipada/components/ConfirmaModal.js